import styled from 'styled-components'

export const Container = styled.div`
    width: 100%;

    color:#000;
    /* .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected{
        background-color: #15558d !important;
        color: #000 !important;
    } */
    .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
        background: #ffffff;
        border-radius: 60px 0px 0px 60px;
        color: ${props => props.theme.colors.primary};
    }
 
    .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-active {
        background: #ffffff;
        color: linear-gradient(172.76deg, #B383C8 0%, #8438A7 100%) !important;
    }
    .ant-menu-item{
        border-radius: 60px 0px 0px 60px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        align-content: center;
        flex-wrap: nowrap;
    }
    .ant-menu{
        background: unset;
        padding-left: 8px;
    }
    .ant-menu-inline, .ant-menu-vertical, .ant-menu-vertical-left{
        border: unset;
    }
    .ant-menu-item a{
        color: #000;
    }
    .ant-menu-item span{
        color: #000;
    }
    .ant-menu-item ::after{
            color: red;
        }
    .ant-menu-item a:hover{
        color: ${props => props.theme.colors.primary};
    }
    .ant-menu-item-selected a, .ant-menu-item-selected a:hover{
        color: ${props => props.theme.colors.primary};
         ::after{
            color: ${props => props.theme.colors.primary};
        }

    }
    .ant-menu-item span:hover{
        color: ${props => props.theme.colors.primary};
    }
    .ant-menu-item, .ant-menu-item-active span{
        color: ${props => props.theme.colors.primary};
    }
    .ant-menu-item-selected span, .ant-menu-item-selected span:hover{
        color: ${props => props.theme.colors.primary};
         ::after{
            color: ${props => props.theme.colors.primary};
        }

    }
`
export const MenuBlock = styled.div`
    width: 100%;
    height: auto;
`